// Runtime half of LayerContent — MaterialType const + mesh-option type guards.
// Pure types live in @scrolly/post-types (MaterialTypeValue + MaterialContent).

import type { Object3DContent } from "@scrolly/post-types";

export const MaterialType = {
    meshStandard: "meshStandard",
    meshBasic: "meshBasic",
    meshLambert: "meshLambert",
    meshPhong: "meshPhong",
    // disabled for now, check release 3.3.0 when
    // these were still included
    // meshToon: "meshToon",
    // dielectric: "dielectric",
    // matcap: "matcap",
    // metal: "metal",
    // plastic: "plastic",
    // seethrough: "seethrough",
    // toon: "toon",
} as const;
export type MaterialType = (typeof MaterialType)[keyof typeof MaterialType];

export const hasMeshOptions = (content: Object3DContent) =>
    ([MaterialType.meshBasic, MaterialType.meshLambert, MaterialType.meshPhong, MaterialType.meshStandard] as readonly string[]).includes(
        content.material.type
    );

export const hasMeshBumpOptions = (content: Object3DContent) =>
    ([MaterialType.meshPhong, MaterialType.meshStandard] as readonly string[]).includes(content.material.type);
